var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('span',{staticClass:"my-space-hero-summary-widget"},_vm._l((_vm.items),function(item){return (item.count)?_c('span',{key:item.key,staticClass:"my-space-hero-chip",on:{"click":_vm.goTasks}},[_c('AppIcon',{attrs:{"name":item.icon}}),_vm._v(_vm._s(item.count)+" "+_vm._s(item.label))],1):_vm._e()}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }